<wl-composable-card [config]="cardConfig">
  <wl-basic-content-partial-top-between
    [content]="content"
    [settings]="settings"
    [context]="context"
  ></wl-basic-content-partial-top-between>
</wl-composable-card>
